<template>
  <div class="cp-go-live main">
    <div class="divider" />

    <div v-if="isActive" class="row">
      <p><i class="fa fa-running icon" />Live Mode</p>
      <p class="value">Your shop is now Live.</p>
      <p class="value">You can get real orders from your customers.</p>
      <p class="value">
        You can still create test orders, just remember to click the Test button
        on the Place Order page.
      </p>
      <!-- <p class="hint">Shop enquiries will be sent to this email.</p> -->
      <div class="save-wrapper">
        <p v-if="updatingActive" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p
          v-else
          class="button is-warning has-text-weight-medium"
          @click="toggleActive"
        >
          <span>Revert to Test Mode</span>
        </p>
      </div>
    </div>

    <div v-else class="row">
      <p><i class="fa fa-umbrella-beach icon" />Test Mode</p>
      <p class="value">Your shop is currently in Test Mode.</p>
      <p class="value">
        You can make test orders to see how the system works and set up your
        shop the way you want.
      </p>
      <p class="value">
        Once you are happy with your setup you can click the Go Live button to
        start taking real orders.
      </p>
      <div class="save-wrapper">
        <p v-if="updatingActive" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p
          v-else
          class="button is-success has-text-weight-medium"
          @click="toggleActive"
        >
          <span>Go Live</span>
        </p>
      </div>
    </div>

    <div v-if="$store.getters.isSuperUser">
      <div class="divider" />

      <div class="row" style="background-color: #eef">
        <p><i class="fa fa-certificate icon" />Admin Approval</p>
        <p class="value">is_approved flag can be used for KYC</p>
        <p class="value">
          For example, allowing delivery or certain payment types.
        </p>
        <div class="save-wrapper">
          <p v-if="updatingApproval" class="button">
            <i class="fa fa-spinner fa-spin" />
          </p>
          <p
            v-else-if="business.is_approved"
            class="button is-warning"
            @click="toggleApproval"
          >
            <span>Un-Approve</span>
          </p>
          <p v-else class="button is-info" @click="toggleApproval">
            <span>Approve</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "CPGoLive",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      updatingActive: false,
      updatingApproval: false,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    isActive() {
      return this.business.is_active;
    },
  },
  mounted() {},
  methods: {
    toggleActive() {
      this.updatingActive = true;
      this.$store
        .dispatch("updateBusinessActive", {
          id: this.business.id,
          is_active: !this.business.is_active,
        })
        .then((res) => {
          this.successToast("Updated!");
          this.business.is_active = res.data.is_active;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingActive = false));
    },
    toggleApproval() {
      this.infoToast("TODO is_approved");
      //
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  margin-top: 6px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.hint {
  margin-top: 6px;
  margin-left: 4px;
  color: grey;
  font-size: 0.9em;
}
</style>
